import { createSvgComponent } from "../../icon/createSvgComponent";
import WelloFill from "@core/icon/assets/wello-fill.svg";
export default createSvgComponent(WelloFill);